// providers
import { ThemeProvider } from "@mui/system";
import { RtlLayout } from "components/common/RtlLayout";
// @mui
import CssBaseline from "@mui/material/CssBaseline";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// theme
import { theme } from "theme/theme";
// type
import type { FC, PropsWithChildren } from "react";
// config
import { ThemeConfig } from "../config";
import { AdapterMomentJalaali } from "@mui/x-date-pickers/AdapterMomentJalaali";
import moment from "moment-jalaali";
import { useThemeContext } from "./ThemeContext";
import { useMemo } from "react";

interface MuiProviderPropTypes {}

export const MuiProvider: FC<PropsWithChildren<MuiProviderPropTypes>> = (
  props
) => {
  const { children } = props;
  const { mode, customTheme } = useThemeContext();
  moment.loadPersian({ dialect: "persian-modern" });

  const currentTheme = useMemo(() =>
    theme({
      mode: mode,
      direction: ThemeConfig.themeDirection,
      customColors: {
        primary: customTheme.primary,
        secondary: customTheme.secondary,
      }
    }),
    [mode, customTheme]
  );

  return (
    <ThemeProvider theme={currentTheme}>
      <RtlLayout>
        <LocalizationProvider dateAdapter={AdapterMomentJalaali}>
          <CssBaseline />
          {children}
        </LocalizationProvider>
      </RtlLayout>
    </ThemeProvider>
  );
};
